import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { EntryPoint } from './types'

export interface ReferralPageViewedEventProperties {
  entry_point: EntryPoint
}

export class ReferralPageViewedEvent extends Event<ReferralPageViewedEventProperties> {
  static displayName = 'Referral Page Viewed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
